import React from "react";

function Footer() {
  return (
    <div className="Footer bg-brand-primary text-white font-brand-secondary p-4 mt-auto flex justify-center">
      <div
        className="Footer-container flex justify-center
            text-center flex-col"
      >
        <div className="Footer-department">
          Virginia Tech Computer Science Department
        </div>
        {window.location.href.endsWith("/jobs") && (
          <div className="Footer-credit">
            Location Services Powered by <a href="https://www.geoapify.com/">Geoapify</a>.
          </div>
        )}
      </div>
    </div>
  );
}

export default Footer;
